module.exports = __webpack_public_path__ + "img/68.989a82c6.jpg";